module.exports = __webpack_public_path__ + "img/116ne.0a67f8a2.svg";